import styled from 'styled-components';

export const FormContent = styled.form`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.35rem 1rem;
  align-items: start;

  /* Os campos recebem a largura da célula do grid, não a largura em % que
     cada um traz por padrão — é isso que alinha tudo em colunas. */
  > div {
    width: 100% !important;
    padding-left: 0;
    padding-right: 0;
  }

  /* Nome completo ocupa a linha inteira. */
  > div:first-child {
    grid-column: 1 / -1;
  }

  > button {
    grid-column: 1 / -1;
    justify-self: center;
    margin-top: 0.75rem;
  }

  p {
    margin-top: 0.5rem;
    color: var(--feedback-danger);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
